module.exports = __webpack_public_path__ + "static/media/nagi_default18e9e1c76bd4f9630683e7daa7bebc82.webp";